{
  "list": {
    "title": "स्मार्ट वाक्यांश",
    "backToDashboard": "डैशबोर्ड",
    "newButton": "नया वाक्यांश",
    "import": "आयात",
    "export": "निर्यात",
    "searchPlaceholder": "कुंजी या विस्तार पाठ द्वारा खोजें...",
    "filterAllCategories": "सभी श्रेणियाँ",
    "header": "वाक्यांश ({{count}})",
    "loading": "वाक्यांश लोड हो रहे हैं...",
    "empty": "कोई वाक्यांश नहीं मिला। अपना पहला स्मार्ट वाक्यांश बनाएँ।",
    "authoredBy": "द्वारा {{name}}",
    "tooltips": {
      "preview": "पूर्वावलोकन",
      "edit": "संपादित करें",
      "delete": "हटाएँ"
    },
    "confirmDelete": "पुष्टि करें",
    "cancelDelete": "रद्द करें",
    "previewLabel": "पूर्वावलोकन:",
    "closePreview": "पूर्वावलोकन बंद करें",
    "toast": {
      "deleted": "वाक्यांश हटाया गया",
      "importComingSoon": "आयात सुविधा जल्द ही आ रही है",
      "exportComingSoon": "निर्यात सुविधा जल्द ही आ रही है"
    }
  },
  "form": {
    "editTitle": "स्मार्ट वाक्यांश संपादित करें",
    "createTitle": "नया स्मार्ट वाक्यांश",
    "fields": {
      "key": "कुंजी",
      "category": "श्रेणी",
      "expansionText": "विस्तार पाठ"
    },
    "required": "*",
    "keyPlaceholder": ".normalexam",
    "keyHelper": "\".\" से शुरू होना चाहिए",
    "categoryUncategorized": "अवर्गीकृत",
    "expansionPlaceholder": "वह पाठ जो शॉर्टकट को प्रतिस्थापित करेगा...",
    "cancel": "रद्द करें",
    "create": "वाक्यांश बनाएँ",
    "update": "वाक्यांश अद्यतन करें",
    "toast": {
      "created": "वाक्यांश बनाया गया",
      "updated": "वाक्यांश अद्यतन किया गया",
      "saveFailed": "वाक्यांश सहेजने में विफल",
      "keyMustStartWithDot": "कुंजी \".\" से शुरू होनी चाहिए",
      "keyTooShort": "कुंजी कम से कम 2 वर्ण की होनी चाहिए",
      "expansionRequired": "विस्तार पाठ आवश्यक है"
    }
  },
  "category": {
    "general": "सामान्य",
    "physicalExam": "शारीरिक परीक्षा",
    "reviewOfSystems": "तंत्र समीक्षा",
    "assessment": "मूल्यांकन",
    "plan": "योजना",
    "instructions": "निर्देश",
    "medications": "दवाएँ",
    "history": "इतिहास"
  }
}
